import styled, { css } from 'styled-components';

import theme from '@/styles/theme';

export const Container = styled.section`
  width: 90%;
  /* max-width: 85.5rem; // 855px */
  margin: 5rem auto 0;
  display: flex;
  flex-direction: column;
`;

export const EventCover = styled.div`
  ${({ theme }) => css`
    padding: 2rem;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${props => props.theme.color.white};
    border-radius: 0.8rem;

    position: relative;
    margin-bottom: 1.8rem;

    figure {
      img {
        width: 100%;
      }
    }

    figcaption {
      color: ${theme.color.white};
      background: ${theme.color.primary};
      display: inline-block;
      padding: 4px 24px;
      font-size: 1.6rem;

      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);

      .figcaption-facebook-svg {
        width: 24px;
        height: 25px;
      }

      .figcaption-whatsapp-svg {
        width: 26px;
        height: 25px;
      }

      .figcaption-twitter-svg {
        width: 27px;
        height: 25px;
      }

      > a {
        margin-left: 8px;
        padding: 0 4px;
        display: inline-block;
      }
    }
  `}
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-gap: 1.7rem;
  align-items: flex-start;
  margin: 1.6rem auto 5rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
`;

export const EventWrapper = styled.article`
  ${({ theme }) => css`
    background: ${theme.color.white};
    border-radius: 0.4rem;

    svg {
      width: 1.73rem;
      height: 1.73rem;
    }
  `}
`;

export const EventHeader = styled.header`
  ${() => css`
    padding: 2rem 0 3rem;
    text-align: center;
    margin: 0 3rem;
  `}
`;

export const EventTitle = styled.h1`
  ${({ theme }) => css`
    color: ${theme.color.primary};
    font-size: 3.4rem;
    font-weight: ${theme.font.weight.bold};
  `}
`;

export const EventDate = styled.div`
  ${({ theme }) => css`
    margin-top: 1.2rem;
    display: flex;
    align-items: center;

    p {
      color: ${theme.color.primary};
      font-size: 1.6rem;
      margin-left: 1rem;
    }
    @media (max-width: 768px) {
      p {
        font-size: 1.4rem;
      }
    }
  `}
`;

export const EventLocation = styled.div`
  ${({ theme }) => css`
    margin-top: 0.4rem;
    display: flex;
    align-items: center;

    p {
      color: ${theme.color.primary};
      font-size: 1.6rem;
      margin-left: 1rem;
    }

    svg path {
      fill: ${theme.color.text} !important;
    }

    @media (max-width: 768px) {
      p {
        font-size: 1.4rem;
      }
    }
  `}
`;

export const Organizer = styled.div`
  ${({ theme }) => css`
    width: 100%;
    background-color: ${theme.color.primary};
    color: ${theme.color.white};
    text-align: center;
    padding: 0.8rem 1.2rem;
    margin-bottom: 3rem;
  `}
`;

export const EventBody = styled.div`
  ${({ theme }) => css`
    color: ${theme.color.subtext};
    font-size: 1.2rem;
    font-weight: ${theme.font.weight.light};
    padding: 0 3rem 3rem;
    overflow: hidden;
    word-break: break-word;
    text-align: justify;

    p {
      margin-bottom: 1rem;
    }
  `}
`;

export const Terms = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.4rem;
    padding: 1.6rem;

    a {
      color: ${theme.color.primary};
      font-weight: 600;
    }

    input {
      min-width: 16px;
      min-height: 16px;
    }
  `}
`;

export const FooterEventContainer = styled.section`
  ${({ theme }) => css`
    background-color: ${theme.color.white};

    margin-bottom: 2.4rem;
  `}
`;

export const FooterEventLocal = styled.div`
  ${({ theme }) => css`
    padding: 2.8rem 20% 6rem;

    display: flex;
    align-items: center;
    gap: 10rem;

    h3 {
      color: ${theme.color.primary};
      font-size: 2.2rem;
      font-weight: 600;
      line-height: 4rem;
    }

    h4 {
      font-size: 2rem;
      > strong {
        font-weight: 600;
      }
    }

    p {
      line-height: 3.2rem;
    }

    button {
      color: ${theme.color.primary};
      border: 1px solid ${theme.color.primary};
      padding: 0.8rem 1.6rem;

      > svg {
        width: 1.8rem;
        height: 1.8rem;
        margin-right: 0.8rem;

        > path {
          fill: ${theme.color.primary};
        }
      }
    }

    @media (max-width: 768px) {
      flex-direction: column;
      justify-content: center;
    }
  `}
`;

export const HelpCentral = styled.div`
  ${({ theme }) => css`
    color: ${theme.color.white};
    background-color: ${theme.color.subtext};
    padding: 2.8rem 24%;

    display: flex;
    align-items: center;
    gap: 0.8rem;

    a {
      margin-left: 0.6rem;
      border: 1px solid ${theme.color.white};
      padding: 0.8rem 1.6rem;
      border-radius: 4px;
      color: ${theme.color.white};
      text-decoration: none;

      :hover {
        filter: brightness(0.9);
      }
    }

    @media (max-width: 768px) {
      padding: 2.8rem 0;
      justify-content: center;

      p {
        text-align: center;
      }
    }

    @media (max-width: 600px) {
      flex-direction: column;
    }
  `}
`;

export const SeatsioContainer = styled.div`
  max-width: 100%;
  height: 500px;
`;
